import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2018e886 from 'nuxt_plugin_plugin_2018e886' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_514edf40 from 'nuxt_plugin_sentryserver_514edf40' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_719f1ed8 from 'nuxt_plugin_sentryclient_719f1ed8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_7a9c9928 from 'nuxt_plugin_plugin_7a9c9928' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_07c41444 from 'nuxt_plugin_cookieuniversalnuxt_07c41444' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_0b6ae5c2 from 'nuxt_plugin_pluginutils_0b6ae5c2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_47dc4eaa from 'nuxt_plugin_pluginrouting_47dc4eaa' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_617d2d05 from 'nuxt_plugin_pluginmain_617d2d05' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_e4522a90 from 'nuxt_plugin_workbox_e4522a90' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_37d5f9cb from 'nuxt_plugin_metaplugin_37d5f9cb' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_571f2c9c from 'nuxt_plugin_axios_571f2c9c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moduleplugin010cfa43_5efd252c from 'nuxt_plugin_moduleplugin010cfa43_5efd252c' // Source: ./module.plugin.010cfa43.mjs (mode: 'all')
import nuxt_plugin_cookieConsent_e1256d40 from 'nuxt_plugin_cookieConsent_e1256d40' // Source: ../plugins/cookieConsent (mode: 'all')
import nuxt_plugin_vuetifythemecache_9b272eee from 'nuxt_plugin_vuetifythemecache_9b272eee' // Source: ../plugins/vuetify-theme-cache (mode: 'all')
import nuxt_plugin_vuetifythemestorage_3871d5c2 from 'nuxt_plugin_vuetifythemestorage_3871d5c2' // Source: ../plugins/vuetify-theme-storage (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_gtag_819d409c from 'nuxt_plugin_gtag_819d409c' // Source: ../plugins/analytics/gtag (mode: 'client')
import nuxt_plugin_tolt_819191bc from 'nuxt_plugin_tolt_819191bc' // Source: ../plugins/analytics/tolt (mode: 'client')
import nuxt_plugin_auth_591e7914 from 'nuxt_plugin_auth_591e7914' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_fetchTemplates_3918d97c from 'nuxt_plugin_fetchTemplates_3918d97c' // Source: ../plugins/fetchTemplates.js (mode: 'client')
import nuxt_plugin_fetchFlows_b5f30014 from 'nuxt_plugin_fetchFlows_b5f30014' // Source: ../plugins/fetchFlows.js (mode: 'client')
import nuxt_plugin_fetchGroups_08410202 from 'nuxt_plugin_fetchGroups_08410202' // Source: ../plugins/fetchGroups.js (mode: 'client')
import nuxt_plugin_fetchSources_1f1a213a from 'nuxt_plugin_fetchSources_1f1a213a' // Source: ../plugins/fetchSources.js (mode: 'client')
import nuxt_plugin_referral_54c007f8 from 'nuxt_plugin_referral_54c007f8' // Source: ../plugins/referral.js (mode: 'client')
import nuxt_plugin_survey_3bbbf4b2 from 'nuxt_plugin_survey_3bbbf4b2' // Source: ../plugins/survey.js (mode: 'client')
import nuxt_plugin_posthog_750c08f6 from 'nuxt_plugin_posthog_750c08f6' // Source: ../plugins/analytics/posthog.js (mode: 'client')
import nuxt_plugin_segment_313b9483 from 'nuxt_plugin_segment_313b9483' // Source: ../plugins/analytics/segment.js (mode: 'client')
import nuxt_plugin_paddle_72ad0cee from 'nuxt_plugin_paddle_72ad0cee' // Source: ../plugins/analytics/paddle (mode: 'client')
import nuxt_plugin_metaPixel_da329496 from 'nuxt_plugin_metaPixel_da329496' // Source: ../plugins/analytics/metaPixel.js (mode: 'client')
import nuxt_plugin_socket_3b036b2e from 'nuxt_plugin_socket_3b036b2e' // Source: ../plugins/socket (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'format-detection', content: 'telephone=no' },
      {
        hid: 'og:image',
        name: 'og:image',
        content: `${this.$config.baseURL}/android-chrome-512x512.png`
      },
      ...i18nHead.meta],

      link: [
      {
        rel: 'preconnect',
        href: 'https://use.typekit.net',
        crossorigin: true
      },
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      ...i18nHead.link]
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2018e886 === 'function') {
    await nuxt_plugin_plugin_2018e886(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_514edf40 === 'function') {
    await nuxt_plugin_sentryserver_514edf40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_719f1ed8 === 'function') {
    await nuxt_plugin_sentryclient_719f1ed8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7a9c9928 === 'function') {
    await nuxt_plugin_plugin_7a9c9928(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_07c41444 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_07c41444(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0b6ae5c2 === 'function') {
    await nuxt_plugin_pluginutils_0b6ae5c2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_47dc4eaa === 'function') {
    await nuxt_plugin_pluginrouting_47dc4eaa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_617d2d05 === 'function') {
    await nuxt_plugin_pluginmain_617d2d05(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_e4522a90 === 'function') {
    await nuxt_plugin_workbox_e4522a90(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_37d5f9cb === 'function') {
    await nuxt_plugin_metaplugin_37d5f9cb(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_571f2c9c === 'function') {
    await nuxt_plugin_axios_571f2c9c(app.context, inject)
  }

  if (typeof nuxt_plugin_moduleplugin010cfa43_5efd252c === 'function') {
    await nuxt_plugin_moduleplugin010cfa43_5efd252c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieConsent_e1256d40 === 'function') {
    await nuxt_plugin_cookieConsent_e1256d40(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetifythemecache_9b272eee === 'function') {
    await nuxt_plugin_vuetifythemecache_9b272eee(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetifythemestorage_3871d5c2 === 'function') {
    await nuxt_plugin_vuetifythemestorage_3871d5c2(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_819d409c === 'function') {
    await nuxt_plugin_gtag_819d409c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tolt_819191bc === 'function') {
    await nuxt_plugin_tolt_819191bc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_591e7914 === 'function') {
    await nuxt_plugin_auth_591e7914(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fetchTemplates_3918d97c === 'function') {
    await nuxt_plugin_fetchTemplates_3918d97c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fetchFlows_b5f30014 === 'function') {
    await nuxt_plugin_fetchFlows_b5f30014(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fetchGroups_08410202 === 'function') {
    await nuxt_plugin_fetchGroups_08410202(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fetchSources_1f1a213a === 'function') {
    await nuxt_plugin_fetchSources_1f1a213a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_referral_54c007f8 === 'function') {
    await nuxt_plugin_referral_54c007f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_survey_3bbbf4b2 === 'function') {
    await nuxt_plugin_survey_3bbbf4b2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthog_750c08f6 === 'function') {
    await nuxt_plugin_posthog_750c08f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_segment_313b9483 === 'function') {
    await nuxt_plugin_segment_313b9483(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paddle_72ad0cee === 'function') {
    await nuxt_plugin_paddle_72ad0cee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metaPixel_da329496 === 'function') {
    await nuxt_plugin_metaPixel_da329496(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socket_3b036b2e === 'function') {
    await nuxt_plugin_socket_3b036b2e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
